import { ForbiddenRouteState } from '@components/common/ForbiddenRouteState';
import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags';
import { useDashboardPermissions } from '@components/utils/DashboardPermissions';
import React from 'react';
import { useReportType } from '../../../../hooks/useReportType';
import { useAnalyticsParams } from '../../../../modules/AnalyticsParams';
import { AnalyticsReportView } from './AnalyticsReportView';
import { useAnalyticsReport } from './hooks/useAnalyticsReport';
export const AnalyticsReportContainer = () => {
    const { analyticsParams } = useAnalyticsParams({
        precision: { excluded: ['WEEK', 'MONTH', 'YEAR'] },
    });
    const { title, bottomContent, banner, backButtonLabel, backButtonTo, exportButton, chart, analyticsBarChart, statsTable, } = useAnalyticsReport(analyticsParams);
    const { hasPermission } = useDashboardPermissions();
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const { reportType } = useReportType();
    const permissionsMap = {
        profit: hasPermission('analytics.profit'),
        orders: hasPermission('analytics.contributions'),
        'average-order-value': hasPermission('analytics.averageContributionValue'),
        'top-products-by-units-sold': hasPermission('analytics.topProducts'),
        'sales-by-country': hasPermission('analytics.salesByCountry'),
        'memberships-total-members': hasPermission('analytics.totalMembers'),
        'memberships-total-free-members': hasPermission('analytics.totalMembers') && dashboardFeatureFlags.memberships.enabled,
        'memberships-members-change': hasPermission('analytics.membersChange'),
        'memberships-free-members-change': hasPermission('analytics.membersChange') && dashboardFeatureFlags.memberships.enabled,
        'membership-top-tiers': hasPermission('analytics.topTiers'),
        'payment-method-used': hasPermission('analytics.paymentMethodUsed'),
        'conversion-rates': hasPermission('analytics.conversionRates'),
        'unique-visitors': hasPermission('analytics.uniqueVisitors'),
        'sales-by-traffic-source': hasPermission('analytics.salesByTrafficSource'),
        'sessions-by-traffic-source': hasPermission('analytics.sessionsByTrafficSource'),
        'sales-by-social-source': hasPermission('analytics.salesBySocialSource'),
        'sessions-by-social-source': hasPermission('analytics.sessionsBySocialSource'),
    };
    if (!permissionsMap[reportType]) {
        return React.createElement(ForbiddenRouteState, null);
    }
    return (React.createElement(AnalyticsReportView, { title: title, bottomContent: bottomContent, banner: banner, backButtonLabel: backButtonLabel, backButtonTo: backButtonTo, exportButton: exportButton, chart: chart, analyticsBarChart: analyticsBarChart, statsTable: statsTable }));
};
